import React from "react";
import { connect } from "react-redux";
import * as userAction from "../../actions/user";
import CountryCodeList from "../shared/CountyCodeList";
import { ReactComponent as Logo } from "./../../assets/images/logo.svg";
//ui Components
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import AtencyTextField from "../shared/AtencyTextField";
import { FormControl } from "@material-ui/core";
import { toast } from "react-toastify";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      callingCode: "+98",
    };
  }
  handleSubmit = async (event) => {
    event.preventDefault();
    try {
      this.props.loading(true);
      await this.props.startLoginUser({
        username: this.state.callingCode + this.state.username,
        password: this.state.password,
      });
      this.props.loading(false);
      this.props.history.push("/");
    } catch (error) {
      this.props.loading(false);

      toast.error(error.response.data.error_description, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };
  handleInputChage = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  getCountryCode = (country) => {
    this.setState({
      callingCode: country.CallingCode,
    });
  };

  render() {
    return (
      <div
        className="login-component"
        style={{
          background: `url(${require("./../../assets/images/login_bg.png")})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundColor: "#192064",
        }}
      >
        <Container maxWidth="xs" className="my-auto">
          <Logo className="pb-6" />
          <form onSubmit={this.handleSubmit}>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              className="dir-ltr"
            >
              <Grid item xs={3}>
                <CountryCodeList setCountryCode={this.getCountryCode} />
              </Grid>
              <Grid item xs={9}>
                <FormControl color="secondary" fullWidth={true}>
                  <AtencyTextField
                    label="نام کاربری"
                    color="secondary"
                    type="text"
                    name="username"
                    value={this.state.username}
                    onChange={this.handleInputChage}
                  ></AtencyTextField>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth={true}>
                  <AtencyTextField
                    label="کلمه عبور"
                    color="secondary"
                    type="password"
                    name="password"
                    className="mt-2"
                    value={this.state.password}
                    onChange={this.handleInputChage}
                  ></AtencyTextField>
                </FormControl>
              </Grid>
              <Grid container justify="center" className="mt-2">
                <button
                  className="mt-3 btn btn-danger px-4 btn"
                  variant="contained"
                  color="primary"
                  type="submit"
                >
                  ورود
                </button>
                <span className="text-light d-block w-100 text-center mt-3">
                  <a href="https://panel.atency.com/Account/ForgotPassword">
                    فراموشی رمز عبور
                  </a>
                </span>
              </Grid>
            </Grid>
          </form>
        </Container>
      </div>
    );
  }
}
export default connect(null, userAction)(Login);
